import React from "react";
import PropTypes from "prop-types";

import SocialLink from "../SocialLink";
import { SOCIAL_LINKS } from "config/constants";

export default function SocialLinks({ className }) {
  return (
    <span className={className}>
      {SOCIAL_LINKS.map(socialLink => {
        return (
          <SocialLink
            key={socialLink.name}
            href={socialLink.url}
            name={socialLink.name}
            description={socialLink.description}
            className={socialLink.gtmClass}
          />
        );
      })}
    </span>
  );
}

SocialLinks.propTypes = {
  className: PropTypes.string,
};
